<template>
  <div>
    <div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />

      <tl-header type="h1">Legacy Data</tl-header>
      <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
        You have only view permission.
      </div>
      <br />
      <div :disabled="!ifTeamleaderAnchorPermission">
        <div class="input-label margintop-24">First PayRoll On Paylief</div>
        <date-picker
          class="datepicker"
          :initialView="'month'"
          :formatDate="'MMMM-yyyy'"
          :maximumView="'year'"
          :minimumView="'month'"
          v-model="firstPayroll"
          :disabled="true"
        />
      </div>
      <div class="margintop-24" :disabled="!ifTeamleaderAnchorPermission">
        <tl-select
          labelText="name"
          label="Year"
          name="Year"
          v-model="year"
          :options="Array.from(Array(10), (x, index) => new Date(firstPayroll).getFullYear() - index)"
          @change="(val)=>{year=val}"
          data-vv-as="Year"
          v-validate="{required: true}"
          :classname="errors.has('Year')"
          :errormsg="errors.first('Year')"
        />
      </div>
      <div class="fourColumnGrid" :disabled="!ifTeamleaderAnchorPermission">
        <div class="mask" v-for="(item, index) in monthList" :key="index" @click="goToAddSalaryRegister(item)">
           <img src="@/assets/error_stepper.svg" class="oval" />
           <div class="month">
             {{` ${item} ${year} `}}
           </div>
        </div>
      </div>

      <pop-up-message
        v-if="showPopup"
        :message="popupMessage"
        :popupType="popupType"
        :popupHeaderMessage="'Confirm Delete'"
      >
        <!-- Author: Vaishnavi
        Date: 10/12/2019
        Issue Description: Consistent buttons across application-->
        <template v-slot:bottomContent>
          <btn-grp>
            <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
            <popup-btn text="Delete" type="primary" @click="deleteEvent" />
          </btn-grp>
        </template>
      </pop-up-message>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "Grades",
  data() {
    return {
      errmsg: "",
      toast: false,
      showAdd: true,
      mode: "add",
      popupType: "Success",
      popupMessage: "",
      showButton: true,
      showPopup: false,
      isFormActive: false,
      errmsg: "",
      currentRecord: {},
      firstPayroll: "",
      monthList: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
      ],
      year: 2020,
      legacyDataValue: false,
      role: ""
    };
  },
  activated() {
    this.fetchAll();
    this.getOrgLeIdList();
  },
  mounted() {
    this.fetchAll();
    this.getOrgLeIdList();
  },
  computed: {
    ...mapState("onboard/salary_grades", {
      salaryGradesDataAll: state => state.data,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    salaryGradesColumnNames() {
      return [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Description",
          key: "description"
        }
      ];
    },
    salaryGradesData() {
      return this.salaryGradesDataAll
        ? this.salaryGradesDataAll[this.leId]
        : [];
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    showAddBtn() {
      return !this.isFormActive;
    },
    isLoading() {
      return this.isFetching;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.legacyDataValue) {
        return true;
        } else {
          return false;
        }
      }
      // else {
      //  return true
      // }
    },
  },
  methods: {
    ...mapActions({
      act_fetchAll: "onboard/settings/payroll_cycle/fetchAll",
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /* function to hide pop-up */
    cancelEvent() {
      this.showPopup = false;
    },

    /* function to open delete confirmation pop-up */
    deleteItem(record) {
      try {
        this.showPopup = true;
        this.popupType = "ConfirmDelete";
        this.popupMessage = "Are you sure you want to delete ?";
        this.currentRecord = record;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** Function to fetch the data from server and populate the data in form */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.leId);
        let payrollSettingsData = res.data.payload.data;
        if (payrollSettingsData) {
          if (this.leId == payrollSettingsData.le_id) {
             this.firstPayroll = payrollSettingsData.firstPayroll;
             this.year = new Date(this.firstPayroll).getFullYear();
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to go to create grade page */
    async goToAddSalaryRegister(month) {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/addSalaryRegister`,
        query: { month: month, year: this.year }
      });
    },

    /* function to go to edit grade(create grade page) */
    async initEditStart(record) {
      try {
        await this.act_changeEditMode({ editMode: true, record: record });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/modifySalaryRegister`,
          query: { month: this.month, year: this.year }
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to delete grade */
    async deleteEvent() {
      try {
        await this.act_delete([this.currentRecord, this.leId]);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
      this.showPopup = false;
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.leId;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.legacyDataValue = data.data.user.permissions.legacy_data ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/form.scss";

.noData {
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.mask {
  width: 258.5px;
  height: 144px;
  border-radius: 8px;
  border: solid 1px #e9e9e9;
  background-color: #ffffff;
  padding: 20px 24px;
  margin: 20px 20px 20px 0px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
}

.oval {
  width: 22px;
  height: 22px;
  // background-color: #ffa000;
}

.month {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  color: #444444;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
